import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

import requestClient from '../../utils/requestClient';
import {resourceMapper} from '../../utils/resourceMapper';
import Image from '../../components/Elements/Image';
import FavouriteButton from '../../components/Elements/FavouriteButton';
import RatingButton from '../../components/Elements/RatingButton';
import DownloadButton from '../../components/Elements/DownloadButton';
import ArticleBreadcrumb from '../../components/Elements/ArticleBreadcrumb';
import RelatedArticles from '../../components/Sections/RelatedArticles';
import { pillarMapper } from '../../utils/pillarMapper';
import PillarPill from '../../components/Elements/PillarPill';
import { trackContentView } from '../../utils/api';

const Article = () => {
  const type = 'recipe'
  const { id } = useParams();
  const [article, setArticle] = useState([]);

  const resource = resourceMapper(type)

  useEffect(() => {
    async function getArticle() {
      const response = await requestClient().get(`/api/v2/recipe/${id}`)
      setArticle(response.data.data);
      trackContentView(id, type)
    }
    getArticle();
  }, []);

  return (article.content ?
    <main>
      <article className='bg-white'>
        <div className='container py-8 lg:py-12'>
          <div className='flex items-center justify-between mb-8'>
            <ArticleBreadcrumb article={article.content} />
            <Link to={`/resources?type=${article.content.content_type}`} className="flex items-center lg:hidden">← RESOURCES</Link>
            {'pillar' in article.content ? (<PillarPill pillar={pillarMapper(article.content.pillar)} size='lg' />) : null}
          </div>

          <div className='max-w-[768px] mx-auto'>
            <h1 className='mb-8'>{article.content.title}</h1>
            {article.content.image ? (
              <Image src={article.content.image} className="aspect-video w-full rounded-xl lg:rounded-2xl" />
            ) : null}

            {article.content.pdf_document && <DownloadButton content={article.content.pdf_document} />}

            <section>
              <div className="mt-8 prose">
                <h2>Ingredients</h2>
                <p className='whitespace-pre-line'>{article.content.ingredients}</p>
              </div>
            </section>

            <section>
              <div className="mt-8 prose">
                <h2>Method</h2>
                <ol>
                  {article.content.steps.map((step, index) => (
                    <li key={index}>{step.description}</li>
                  ))}
                </ol>
              </div>
            </section>
            {resource.rating || resource.favourite ?
              <div className="mt-8 py-4 border-t border-b flex items-center justify-between">
                {resource.rating ? <RatingButton article={article.content} /> : null}
                {resource.favourite ? <FavouriteButton article={article.content} favourited={article.favourited} /> : null}
              </div> : null}
          </div>
        </div>
      </article>
      <RelatedArticles article={article} />
    </main>
    : null);
};

export default Article;
